<style lang="less" scoped>
  .v-input {
    /deep/ .v-input__icon--append {
      opacity: 0;
    }
  }
</style>
<template>
  <v-select
    v-if="type === 'select'"
    :value="value"
    :items="account_titles"
    item-value="id"
    item-text="full_name"
    :placeholder="name"
    readonly
    v-bind="$attrs"
  />
  <span v-else>{{ name }}</span>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    inheritAttrs: false,
    props: {
      type: {
        type: String,
        // '' or 'select'
        default: ''
      },
      value: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters('async', ['account_titles', 'account_titles_hash']),
      name() {
        if (!this.value) return '未设置';
        const title = this.account_titles_hash[this.value];
        const not_found = '未找到';
        return title ? title.full_name : not_found;
      }
    }
  }
</script>
